<template>
    <textarea 
        class="form-control"
        :name="name"
        :placeholder="placeholder"
        :style="style"
        :value="modelValue"
        :autocomplete="autocomplete"
        @input="$emit('update:modelValue', $event.target.value)"
        >
    </textarea>
    <label><slot name="label"></slot></label>
    <span class="message" v-if="validMessageCom !== ''" :class="{ 'text-success': isValidCom, 'text-danger': !isValidCom }">
            {{ validMessage }}
    </span>
</template>
<script>
export default {
    name: 'OTextarea',
    props: {
        name: {
            type: String,
        },
        placeholder: {
            type: String,
        },
        id: {
            type: String,
        },
        style: {
            type: [String, Object],
        },
        for:{
            type: String,
        },
        modelValue:{
            type: String
        },
        isValid:{
            type: Boolean,
            default: true
        },
        validMessage:{
            type: String,
            default: ''
        },
        autocomplete:{
            type: String,
        }
    },
    computed:{
        validMessageCom: function() {
            if(this.validMessage === undefined){
                return ''
            }
            return this.validMessage;
        },      
        isValidCom: function(){
            if(this.isValid === undefined){
                return true;
            }
            return this.isValid;
        }
    }
}
</script> 

<style scoped>
.form-control:focus {
    border-color: var(--primary-color, #F93E3E) !important;
    box-shadow: 0 0 0 0.25rem var(--secondary-color, #FEE9E9) !important;
}

.message {
    position: relative;
    margin-top: 5px;
    text-align: left;
}

.text-success {
    color: var(--success-color, #22c55e);
}

.text-danger {
    color: var(--danger-color, #ef4444);
}
</style>